export const SIGNOUT_USER_ON_AUTHENTICATION_FAIL = 'SIGNOUT_USER_ON_AUTHENTICATION_FAIL';